import BotService from 'modules/bot/botService';
import Errors from 'modules/shared/error/errors';
import { getHistory } from 'modules/store';

const prefix = 'BOT_MESSAGES';

const actions = {

  FETCH_MESSAGES_STARTED: `${prefix}_FETCH_MESSAGES_STARTED`,
  FETCH_MESSAGES_SUCCESS: `${prefix}_FETCH_MESSAGES_SUCCESS`,
  FETCH_MESSAGES_ERROR: `${prefix}_FETCH_MESSAGES_ERROR`,

  doFetchMessages: (id) => async (
    dispatch,
    getState,
  ) => {
    try {
      dispatch({
        type: actions.FETCH_MESSAGES_STARTED
      });

      const response = await BotService.listMessages(id);

      dispatch({
        type: actions.FETCH_MESSAGES_SUCCESS,
        payload: response
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: actions.FETCH_MESSAGES_ERROR,
      });
    }
  },

  doFetchMessageDetails: (id, phoneNumber) => async (
    dispatch,
    getState,
  ) => {
    try {
      dispatch({
        type: actions.FETCH_MESSAGES_STARTED
      });

      const response = await BotService.getMessageDetails(id, phoneNumber);

      dispatch({
        type: actions.FETCH_MESSAGES_SUCCESS,
        payload: response
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: actions.FETCH_MESSAGES_ERROR,
      });
    }
  }
};

export default actions;
